import { useEffect } from "react";
import { setHeaderName } from "../../../services/SetHeaderName";
import ReactSummernote from "react-summernote";
import "./style/EmailTemplate.scss";
import { EmailTemplateList } from "./components/EmailTemplatesList";
import { NutrionistEmailTemplate } from "./NutrionistEmailTemplate";


export const EmailTemplate = () => {
    // const onChange = (content) => {
    //     console.log("onChange", content);
    //   };

    let role = JSON.parse(localStorage.getItem('user'));

    // console.log(role.role)
    return (
        <>
            {/* {
                // role.role == "Admin" ? 
                    <EmailTemplateList /> :
                     <NutrionistEmailTemplate />
            } */}
            <EmailTemplateList />
            <NutrionistEmailTemplate />
        </>
    )
}
